/**
 * 用户信息
 */
import { getToken, removeToken, setToken } from '@/utils/auth';
import { loginApi, getInfo, logout } from '@/api/user';
import { getTalkytimesUserInfo } from '@/api/talkytimes/user';
import request from '@/api/request';
import { clearAllConnections } from '@/utils/muti_chat';
import Cookies from 'js-cookie';
import sseManager from '@/utils/sseManager';
import globalWebSocketManager from '@/utils/globalWebSocketManager';
import { performFullCleanup } from '@/utils/cleanup';

export default {
  name: 'user',
  state: {
    roles: [],
    user: {},
    permissions: [],
    sensitiveWords: [], // 敏感词数组,初始为空数组
  },
  mutations: {
    SET_USER(state, userInfo) {
      state.user = userInfo.user;
      state.roles = userInfo.roles;
      state.permissions = userInfo.permissions;
    },
    SET_SENSITIVE_WORDS(state, words) {
      state.sensitiveWords = words;
    },
  },
  actions: {
    async fetchSensitiveWords({ commit }) {
      // const res = await request({
      //   url: '/mf/sensitiveWord/list',
      //   method: 'get',
      //   params: {
      //     platformType: localStorage.getItem('platform') || 'dating',
      //   },
      // });
      // let sensitiveWords =
      //   res.rows?.map((item) => item.sensitiveWord.split('||')).flat() || [];
      // console.log('敏感词', sensitiveWords);
      commit('SET_SENSITIVE_WORDS', []);
    },
    // 登录
    async Login({ commit, dispatch }, params) {
      let { username, password } = params;
      let data = {
        username,
        password,
        clientId: process.env.VUE_APP_CLIENT_ID,
        grantType: 'password',
        tenantId: process.env.VUE_APP_TENANT_Id,
        rememberMe: false,
      };
      let res = await loginApi(data);
      if (res.code != 200) {
        return res;
      }
      console.log('登录返回', res);
      setToken(res.data.access_token);

      localStorage.setItem('platform', 'talkytimes');
      await dispatch('getInfo');

      // 登录成功后获取账号列表
      try {
        await dispatch('accountList/fetchAccountList', true, { root: true });

        // 登录成功后初始化SSE连接
        sseManager.init();
        // 登录成功后初始化全局WebSocket连接
        globalWebSocketManager.init();
      } catch (error) {
        console.error('获取账号列表失败:', error);
      }

      return res;
    },
    // 获取用户信息
    async getInfo({ commit, dispatch }) {
      return;
      let res = {};
      res = await getInfo();
      await dispatch('getPdToken');
      if (res.code == 200) {
        commit('SET_USER', { ...res.data });
      }
    },
    async setUserInfo({ commit }, userInfo) {
      commit('SET_USER', { ...userInfo });
    },
    async getPdToken() {
      // 批量设置多个 cookie
      const cookies = {
        'tld-token':
          'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJyb2xlIjoidXNlciIsImlzcyI6ImRlZiIsInZlciI6IjEuMSIsImlhdCI6MTc1NTE0ODk1MywiZXhwIjoxNzU3ODI3MzUzLCJzdWIiOjY5NTkzMDQ4fQ.t-lvzS0t2TurgW6KroyZPAJHDx47UTSOA5f_yreq8C0',
      };

      // 需要遍历对象来设置
      Object.keys(cookies).forEach((key) => {
        Cookies.set(key, cookies[key]);
      });
    },
    // 退出登录
    async Logout({ commit, dispatch }) {
      try {
        // 先清理用户状态
        commit('SET_USER', {});

        // 执行完整的清理操作
        performFullCleanup();
        removeToken();

        // 清理socket相关资源（等待完全清理完成）
        await clearAllConnections();

        // 断开SSE连接
        sseManager.disconnect();
        // 断开全局WebSocket连接
        globalWebSocketManager.disconnect();

        // 最后调用后端退出登录API
        await logout();

        // 再次确保清理（防止API调用期间有新的数据写入）
        performFullCleanup();
        removeToken();

        console.log('退出登录完成，所有存储、定时器和缓存已清理');
      } catch (error) {
        console.error('退出登录过程中出现错误:', error);
        // 即使API调用失败，也要确保本地清理完成
        commit('SET_USER', {});
        performFullCleanup();
        removeToken();
      }
    },
  },
};
